{
  "subtitle_count": "{n} proyecto | {n} proyectos",
  "new_project": "Nuevo proyecto",
  "empty_title": "Aún no tienes proyectos",
  "empty_subtitle": "Crea el primero para organizar tus tareas.",
  "create_project": "Crear proyecto",
  "no_description": "Sin descripción.",
  "workspace_tag": "Todo el workspace",
  "group_none": "Sin equipo",
  "private_project": "Proyecto privado",
  "favorite_add": "Agregar a favoritos",
  "favorite_remove": "Quitar de favoritos",
  "favorite_error": "No se pudo actualizar el favorito.",
  "members_count_title": "{n} miembros explícitos",
  "tasks_count": "{n} tarea | {n} tareas",
  "filters": {
    "search_placeholder": "Buscar proyecto…",
    "department_label": "Equipo",
    "department_all": "Todos los equipos",
    "health_label": "Estado",
    "health_all": "Todos los estados",
    "favorites_only": "Solo favoritos",
    "clear": "Limpiar filtros",
    "n_selected": "{n} seleccionado | {n} seleccionados",
    "no_match_title": "Ningún proyecto coincide",
    "no_match_body": "Prueba con otros filtros o límpialos."
  },
  "modal": {
    "title": "Nuevo proyecto",
    "field_name": "Nombre",
    "field_description": "Descripción",
    "field_color": "Color",
    "field_department": "Equipo",
    "field_optional": "(opcional)",
    "department_all": "Visible para todo el workspace",
    "department_only": "Solo {name}",
    "department_help": "Si eliges un equipo, solo sus miembros (más owners/admins) podrán ver el proyecto.",
    "private_label": "Proyecto privado",
    "private_help": "Solo los miembros que añadas explícitamente podrán verlo, ignorando el equipo seleccionado.",
    "cancel": "Cancelar",
    "submit": "Crear proyecto",
    "error_generic": "Error creando proyecto."
  }
}
